import { PortalConfigDealer, PortalConfigLender } from '../types';

export const portalDefaultConfigDealer: PortalConfigDealer = {
  multiLocationManagement: false,
  enhancedStagesFlow: false,
  messagingModule: false,
};

export const portalDefaultConfigLender: PortalConfigLender = {
  allowSyndication: false,
  allowLMS: false,
  multiLocationManagement: false,
  enhancedStagesFlow: false,
  subsidyCalculator: false,
  messagingModule: false,
};
